module.exports = __webpack_public_path__ + "static/team-1-2ffaf8464c9d8d2e53c7e465e789ac2a.jpg";